import { rgba } from 'polished';
import styled from 'styled-components';

export const StyledForm = styled.form`
  width: 100%;
  max-width: ${({ theme }) => theme.dimensions.searchForm.width};
  z-index: ${({ theme }) => theme.zindexes.search};
`;

export const StyledTableWrapper = styled.div`
  width: 100%;
  overflow: auto;
`;

/* === Customer Cell (avatar + stacked name/phone) === */

export const StyledCustomerCell = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
`;

export const StyledCustomerAvatar = styled.div<{ name?: string }>`
  width: 2rem;
  height: 2rem;
  border-radius: 999px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.colors.text.secondary};
  background-color: ${({ theme }) =>
    rgba(theme.colors.text.primary, 0.05)};
  border: 1px solid ${({ theme }) => rgba(theme.colors.text.primary, 0.06)};
`;

export const StyledCustomerInfo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const StyledCustomerName = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
  letter-spacing: -0.005em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.25;
`;

export const StyledCustomerSubtitle = styled.span`
  font-size: 0.75rem;
  color: ${({ theme }) => rgba(theme.colors.text.secondary, 0.7)};
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
  margin-top: 0.0625rem;
`;

/* === Phone (mono-ish, dimmed) === */

export const StyledPhoneCell = styled.span`
  font-size: 0.875rem;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.01em;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

/* === City pill === */

export const StyledCityPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.625rem;
  border-radius: 999px;
  background-color: ${({ theme }) =>
    rgba(theme.colors.text.secondary, 0.06)};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 0.78125rem;
  font-weight: 500;
  border: 1px solid ${({ theme }) => rgba(theme.colors.text.primary, 0.05)};

  &::before {
    content: '';
    width: 5px;
    height: 5px;
    border-radius: 999px;
    background: ${({ theme }) => theme.colors.accent};
  }
`;

/* === Total orders count === */

export const StyledOrderCount = styled.div`
  display: inline-flex;
  align-items: baseline;
  gap: 0.3125rem;
  font-variant-numeric: tabular-nums;

  strong {
    font-size: 0.9375rem;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.primary};
    letter-spacing: -0.005em;
  }
  span {
    font-size: 0.75rem;
    color: ${({ theme }) => rgba(theme.colors.text.secondary, 0.65)};
    font-weight: 400;
  }
`;

/* === Value cell (currency) === */

export const StyledValueCell = styled.div`
  display: inline-flex;
  align-items: baseline;
  gap: 0.3125rem;
  font-variant-numeric: tabular-nums;

  strong {
    font-size: 0.9375rem;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.primary};
    letter-spacing: -0.005em;
  }
  span {
    font-size: 0.6875rem;
    font-weight: 500;
    color: ${({ theme }) => rgba(theme.colors.text.secondary, 0.6)};
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
`;

/* === Action button column wrapper === */

export const StyledActionCell = styled.div`
  display: flex;
  justify-content: flex-end;
`;
